import { Link, useParams, useRouteMatch } from 'react-router-dom';
import { useCatSolr } from './hooks/useCatSolr';
import THLSkeleton from './common/THLSkeleton';
import { HtmlCustom } from './common/HtmlCustom';
import React, { useEffect, useState } from 'react';
import './css/CatalogFrame.scss';
import { CollInfo } from './CollInfo';
import { NavSearch } from './search/NavSearch';
import { Tab, Tabs } from 'react-bootstrap';
import CatalogSettings from './common/CatalogSettings';
import { getCatalogInfo } from './CatalogFrame';
import { useBiblStore } from './hooks/useBiblStore';

export function CollectionSummary() {
    const biblStore = useBiblStore();
    const [collsLoaded, setCollsLoaded] = useState(false);
    const [key, setKey] = useState('search'); // change back to 'search'
    const params = useParams(); // Get URL Params
    const coll = params?.coll;
    const query = {
        q: `subtype:(collection edition)`,
        fq: ['type:tibbibl', `coll:${coll}`],
        facet: true,
        'json.facet':
            '{"subtype": {"type":"terms", "field":"subtype","limit":-1}}',
        fl: '*',
        rows: 100,
    };
    const {
        isLoading: isCollInfoLoading,
        data: collInfo,
        isError: isCollInfoError,
        error: collInfoError,
    } = useCatSolr(query);

    // Queries SOLR for all collection and edition bibls and stores in BiblStore organized by collection for easier access and disambiguation of edition sigla
    useEffect(() => {
        // Add mdl-catalog class to body for scroll control of split frame
        document.body.classList.add('catframe');
        // Load Catalog info from search
        if (!biblStore?.collinfo) {
            const promise = getCatalogInfo();
            promise
                .then((resp) => {
                    // console.log('data in promise', resp);
                    if (resp?.data?.response?.docs?.length > 0) {
                        biblStore.setCollInfo(resp.data.response);
                    }
                })
                .finally(() => {
                    setCollsLoaded(true);
                });
        } else if (!collsLoaded) {
            // console.log('already bibstor coll info', bibStore.collinfo);
            setCollsLoaded(true);
        }
        return () => {
            // remove mdl-catalog class from body on unmount
            document.body.classList.remove('catframe');
        };
    }, []);

    if (isCollInfoLoading) {
        return <THLSkeleton />;
    }
    if (!collInfo?.docs?.length || collInfo?.docs?.length < 1) {
        return <p>No Collection, {coll}, to display!</p>;
    }
    const colldoc = collInfo.docs.filter((d) => d.subtype === 'collection');
    const colleds = collInfo.docs.filter((d) => d.subtype === 'edition');
    // console.log("Coll info in coll summary", collInfo);
    return (
        <div className="l-catalog-wrapper">
            <div className="summary">
                <CollInfo
                    doc={colldoc[0]}
                    eds={colleds}
                    showEds={true}
                    showHomeLink={true}
                />
            </div>

            <div className="searchforms p-2" style={{ maxWidth: '30vw' }}>
                <Tabs
                    id="catsumopts"
                    activeKey={key}
                    onSelect={(k) => setKey(k)}
                    className="mb-3"
                >
                    <Tab eventKey="search" title="Search">
                        <div className="search-form">
                            <NavSearch />
                        </div>
                    </Tab>
                    <Tab eventKey="settings" title="Settings">
                        <CatalogSettings />
                    </Tab>
                </Tabs>
                {/*
                <div className="search-form">
                    <NavSearch />
                </div>*/}
            </div>
        </div>
    );
}
